/** @format */

export const usermanService = "/v2/user-services";
export const referenceService = "/v2/reference-services";
export const planningService = "/v2/planning-services";
export const realizationService = "/v2/realization-services";
export const reportService = "/v2/report-services";
export const notificationService = "/v2/message-broker-services";
